/* global VXConfig */
import Flux from '../../flux/Flux';
import {eurToCoin, formatCurrency} from '../../utils/CommonUtils.js';

const {Currency, CurrencySymbol, DailyBonuses} = Flux.Constants;
/**
 * @param {string} currency
 * @returns {string}
 */
function currencySymbol(currency) {
    switch (currency) {
        case Currency.EUR:
            return CurrencySymbol.EUR;
        case Currency.CHF:
            return CurrencySymbol.CHF;
        case Currency.VXC:
            return CurrencySymbol.VXC;
        default:
            return CurrencySymbol.EUR;
    }
}

/**
 * @param {?{value: number, currency: string}} price
 * @returns {string}
 */
function formatPrice(price) {
	const {value = 0, currency = ''} = price ? price : {};
	if (isCurrencyVoucher(price)) {
		return price.value + " Voucher";
	}

	return (value !== 0 && value !== null)
		? formatCurrency(value, false, currency)
		: '';
}

/**
 * @param {?{value: string, unit: string}} effect
 * @returns {string}
 */
function formatEffectAsPlainText(effect) {
	const {value = '', unit = ''} = effect ? effect : {};
	switch (unit) {
		case 'currency':
			return eurToCoin(value) + " " + CurrencySymbol.VXC;
		case 'items':
			return value + ' x'; // 42 x something
		case 'percent':
			return value + '%';
		default:
			break;
	}
	return '';
}

/**
 * @param {Array}translations
 * @return {string}
 */
function getGiftNameByLang(translations) {
	translations = translations ? translations : [];
	const gift   = translations.find(({language}) => language === VXConfig.language);
	return undefined === gift ? '' : gift.value;
}

/**
 * @param {Array} conditions
 * @return {string}
 */
function getTopUpGteThenValue(conditions = []) {
	const condition = (conditions ? conditions : []).find(({name}) => name === 'TopUpGteThen');
	return undefined === condition ? '' : condition.value;
}

/**
 * @param {string} offer
 * @param {object} effect
 * @return {boolean}
 */
const isMerchAndHasCode = (offer, effect) => (
	DailyBonuses.offers.MERCHANDISE === offer
	&& typeof effect !== 'undefined'
	&& !!effect
	&& typeof effect.code !== 'undefined'
	&& !!effect.code
	&& effect.code.length > 0
);

/**
 * @param {array} conditions
 * @return {boolean}
 */
const needVipYesterdayOffer = (conditions) => (
	conditions.findIndex(({name, value}) => name === 'VipOnly' && (value === 'true' || JSON.stringify(value) === 'true' || value === '1')) !== -1
);

/**
 * @param {object} price
 * @return {boolean}
 */
function isCurrencyVoucher(price) {
	return price && price.currency === Flux.Constants.Currency.VOU;
}



export {
	currencySymbol,
	formatPrice,
	formatEffectAsPlainText,
	getGiftNameByLang,
	getTopUpGteThenValue,
	isMerchAndHasCode,
	needVipYesterdayOffer,
	isCurrencyVoucher,
};
